import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel } from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { PROGRAM_PRICE_STATE_OPTIONS, applyProgramPriceState, programPriceStateOf } from "./programPriceState";

/** KB-4181 — the program modal's Priced / Free / Price unknown selector (rules in `./programPriceState`). */
export const ProgramPriceStateField: React.FC<{ form: UseFormReturn<any> }> = ({ form }) => {
  const state = programPriceStateOf(form.watch("priceState"));
  const selected = state ?? "priced";
  const help = PROGRAM_PRICE_STATE_OPTIONS.find((o) => o.value === selected)?.help;
  return (
    <FormField
      control={form.control}
      name="priceState"
      render={() => (
        <FormItem>
          <FormLabel>Price</FormLabel>
          <RadioGroup
            aria-label="Program price"
            className="flex flex-wrap gap-6"
            value={selected}
            onValueChange={(v) => applyProgramPriceState(form, programPriceStateOf(v))}
          >
            {PROGRAM_PRICE_STATE_OPTIONS.map((o) => (
              <div key={o.value} className="flex items-center gap-2">
                <RadioGroupItem value={o.value} id={`program-price-state-${o.value}`} />
                <Label htmlFor={`program-price-state-${o.value}`}>{o.label}</Label>
              </div>
            ))}
          </RadioGroup>
          {help && <p className="text-sm text-muted-foreground mt-1">{help}</p>}
        </FormItem>
      )}
    />
  );
};
